import apiClient from '../client';
import $U from '../urls';

export const getCurrentUser = () => {
  return apiClient.request('GET', $U.CURRENT_USER);
};

export const loginUser = (email, password) => {
  const data = { email, password };

  return apiClient.request('POST', $U.LOGIN, data);
};

export const logoutUser = () => {
  return apiClient.request('POST', $U.LOGOUT);
};

export const registerUser = form => {
  return apiClient.request('POST', $U.REGISTER, form);
};

export const guestLogin = email => {
  return apiClient.request('POST', $U.GUEST_LOGIN, {
    user_email: email,
  });
};

export const changeEmail = (newEmail, newEmailConfirm, password) => {
  const data = {
    email: newEmail,
    repeat_email: newEmailConfirm,
    password,
  };

  return apiClient.request('POST', $U.EMAIL_CHANGE, data);
};

export const changePassword = (
  oldPassword,
  newPassword,
  newPasswordConfirm,
) => {
  const data = {
    old_password: oldPassword,
    new_password1: newPassword,
    new_password2: newPasswordConfirm,
  };

  return apiClient.request('POST', $U.PASSWORD_CHANGE, data);
};

export const resetPassword = email => {
  const data = { email };

  return apiClient.request('POST', $U.PASSWORD_RESET, data);
};

export const fetchProfile = () => {
  return apiClient.request('GET', $U.PROFILE);
};

export const updateProfile = form => {
  return apiClient.request('PATCH', $U.PROFILE, form);
};
